module.exports = "/fast-coin/img/coin/anim/out_2/out_2_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_003.png
// module id = 2309
// module chunks = 5